import { Box, Paper, Typography, Button, Stack, ButtonGroup } from '@mui/material';
import Grid from '@mui/material/Grid';
import { FormMode } from '../utils/extensions/constantEx';

export default function EmployeeFormHeader(props) {
    const { formMode, handleEditClick, handleSaveClick, handleCancelClick, handleDeleteClick } = props;

    return (

        <Paper sx={{ zIndex: '900' }}>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="stretch"
            >
                <Grid size={2}>
                    <Typography variant="h5" sx={{ p: 2 }}>
                        {
                            formMode === FormMode.EditMode ? 'Edit Employee' :
                                formMode === FormMode.NewMode ? 'New Employee' : 'View Employee'
                        }
                    </Typography>
                </Grid>
                <Grid size={10}>
                    <Box sx={{ pr: 1, float: 'right', paddingTop: '14px' }}>
                        <Stack direction="row" spacing={2}>
                            {
                                formMode === FormMode.ViewMode &&
                                <Button variant="contained" color="error" onClick={handleDeleteClick}>Delete</Button>
                            }
                            {
                                formMode === FormMode.ViewMode &&
                                <Button variant="contained" onClick={handleEditClick}>Edit</Button>
                            }
                            {
                                formMode !== FormMode.ViewMode &&
                                <Button variant="contained" onClick={handleSaveClick}>Save</Button>
                            }
                            <Button variant="outlined" onClick={handleCancelClick}>
                                {formMode === FormMode.ViewMode ? 'Close' : 'Cancel'}
                            </Button>
                        </Stack>

                    </Box>
                </Grid>
            </Grid>
        </Paper>

    );
}
